export default defineNuxtRouteMiddleware(async (to, from) => {
  // Don't redirect if already on KDS page, login, or settings
  if (to.path === '/kds' || to.path === '/login' || to.path === '/settings') {
    return
  }

  // Don't redirect if not authenticated - let auth middleware handle it
  const userStore = useUserStore()
  if (!userStore.isAuthenticated) {
    return
  }

  // Check device type from Tauri first (more reliable than DB setting)
  try {
    const { invoke } = await import('@tauri-apps/api/core')
    const deviceType = await invoke('get_device_type')

    if (deviceType === 'kds') {
      console.log('[kds-redirect] Device type is kds, redirecting to /kds from', to.path)
      return navigateTo('/kds')
    }
  } catch (err) {
    // Not in Tauri or no device type, fall back to database setting
  }

  const { getPosSetting, isDbReady } = usePosDatabase()

  if (!isDbReady.value) {
    return
  }

  try {
    const isKdsMode = await getPosSetting('isKdsMode')

    if (isKdsMode === '1') {
      console.log('[kds-redirect] KDS mode enabled, redirecting to /kds from', to.path)
      return navigateTo('/kds')
    }
  } catch (err) {
    console.warn('Failed to check KDS mode:', err)
  }
})
